/**
 * De onde a forma de pagamento é aceita. null = todas as origens.
 * Ver o mesmo tipo em services/configuracaoFormasPagamento para a semântica dos baldes.
 */
export type OrigemPedidoAceita =
    | "CLIENTE_DELIVERY"
    | "CLIENTE_RETIRADA"
    | "CLIENTE_MESA"
    | "CLIENTE"
    | "REGISTRADOR"
    | null

export interface FormaPagamentoItem {
    idFormaPagamento: number
    descricaoFormaPagamento: string
    /** Nome padrao (global) da forma; usado como sugestao/placeholder do nome customizado. */
    descricaoPadrao?: string | null
    /** Nome customizado SUGERIDO no cadastro global; vira placeholder/valor efetivo se a loja nao definir o seu. */
    descricaoPersonalizadaSugerida?: string | null
    /** Nome customizado que a loja definiu; null/vazio = usa o sugerido global ou, na falta, o padrao. */
    descricaoPersonalizada?: string | null
    associado: boolean
    ordemExib: number
    desconto: number | null
    tipoPdv: string | null
    codigoPdv: string | null
    chavePix: string | null
    tipoChavePix: string | null
    codigoQrCodePix: string | null
    origemPedidoAceita: OrigemPedidoAceita
    pix: boolean
}

export interface ConfiguracaoFormasDePagamentoModel {
    formasPagamento: FormaPagamentoItem[]
}

export const ConfiguracaoFormasDePagamentoInicial: ConfiguracaoFormasDePagamentoModel = {
    formasPagamento: [],
}
